import { useEffect, useState } from "react";
import JobZImage from "../../../common/jobz-img";
import { adminService } from "../../../../services/admin-service";
import { AdminPageHeader, AdminPanel, EmptyState, StatusBadge, formatDate } from "./admin-ui";

function AdminMediaPage() {
    const [media, setMedia] = useState([]);
    const [message, setMessage] = useState("");

    const load = () => adminService.media().then((data) => setMedia(data.media || [])).catch((error) => setMessage(error.message));

    useEffect(() => {
        load();
    }, []);

    const cleanup = async () => {
        try {
            const result = await adminService.cleanupMedia();
            setMessage(result.message || "Media cleanup checked.");
            load();
        } catch (error) {
            setMessage(error.message);
        }
    };

    return (
        <>
            <AdminPageHeader title="R2 Media Library" subtitle="Uploaded images and private file metadata" />
            {message && <div className="alert alert-info">{message}</div>}
            <AdminPanel title="Media Assets" icon="fa fa-images" right={<button className="btn btn-sm btn-outline-primary" type="button" onClick={cleanup}>Cleanup Orphans</button>}>
                <div className="table-responsive">
                    <table className="table table-bordered">
                        <thead><tr><th>Preview</th><th>Type</th><th>Owner</th><th>Object Key</th><th>Visibility</th><th>Created</th></tr></thead>
                        <tbody>
                            {media.length === 0 ? (
                                <tr><td colSpan="6"><EmptyState text="No uploaded media found." /></td></tr>
                            ) : media.map((item) => (
                                <tr key={`${item.type}-${item.id}-${item.object_key}`}>
                                    <td style={{ width: 86 }}>
                                        {item.public_url ? <JobZImage src={item.public_url} alt={item.type} /> : <span className="fa fa-file fa-2x text-muted" />}
                                    </td>
                                    <td>{item.type}</td>
                                    <td>{item.owner_name || ""}<div className="text-muted">{item.owner_email || item.entity_title || ""}</div></td>
                                    <td><small>{item.object_key}</small></td>
                                    <td><StatusBadge status={item.visibility || "private"} /></td>
                                    <td>{formatDate(item.created_at)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </AdminPanel>
        </>
    );
}

export default AdminMediaPage;
